// extracted by mini-css-extract-plugin
module.exports = {"small":"_3BQ5num49g-button-size-small-small","circle":"_3H9QGSR99_-button-size-small-circle","pill":"_2jxtJq7tsP-button-size-small-pill"};